import React from "react";
import { useState, useEffect } from "react";
import styles from "./MyApplicationsMain.module.css";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import greater from "../../../assets/images/greater.svg";
import greater2 from "../../../assets/images/greater2.svg";
import confirmation from "../../../assets/images/confirmation.svg";
import cancel from "../../../assets/images/cancel.svg";
import print from "../../../assets/images/print.svg";

import { allApplicationsApi } from "../../../config/allApplicationsApi";
import { updateApplicationApi } from "../../../config/updateApplicationApi";

import moment from "moment";
import { FaGreaterThan } from "react-icons/fa";

import { Link, useHistory } from "react-router-dom";

import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from "mdbreact";

import Tooltip from "@material-ui/core/Tooltip";
import { Divider } from "@material-ui/core";

import { IoChevronDownOutline } from "react-icons/io5";
import Collapsible from 'react-collapsible';

function MyApplicationsMain() {
  const [toggleState, setToggleState] = useState(0);
  const [loader, setLoader] = useState(true);
  // const [loader, setLoader] = useState(false);

  const [allApplications, setAllApplications] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [pending, setPending] = useState([]);
  const [canceled, setCanceled] = useState([]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const allTabs = [
    { name: "All applications" },
    { name: "Completed" },
    { name: "Pending" },
    { name: "Canceled" },
  ];
  const allConts = [
    { app: allApplications, error: "No Applications Available." },
    { app: completed, error: "No Applications Was Completed." },
    { app: pending, error: "No Applications Is Pending." },
    { app: canceled, error: "No Applications Was Canceled." },
  ];
  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const allApplications = async (token) => {
        const allapplications = await allApplicationsApi(token);

        if (allapplications.data) {
          console.log(allapplications.data.data);

          const Applications = await allapplications.data.data;
          Applications.reverse();

          setAllApplications([]);
          setPending([]);
          setCompleted([]);
          setCanceled([]);
          Applications.map((value, index) => {
            if (value.status === "CANCELLED") {
              setAllApplications((allApplications) => [
                ...allApplications,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                },
              ]);

              setCanceled((canceled) => [
                ...canceled,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,
                  status: value.payment_status,

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                },
              ]);
            } else if (
              value.status === "SUCCESSFUL" ||
              value.status === "REJECTED"
            ) {
              setAllApplications((allApplications) => [
                ...allApplications,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                },
              ]);
              setCompleted((completed) => [
                ...completed,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                },
              ]);
            } else {
              setAllApplications((allApplications) => [
                ...allApplications,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                },
              ]);
              setPending((pending) => [
                ...pending,
                {
                  country: value.destination.display_name,
                  id: value._id,
                  date: value.created_at,
                  cost: value.cost.total_cost,
                  payment: value.payment_gateway,

                  visa_type: value.visa_package.name,
                  status: value.status,
                  step: value.step,
                },
              ]);
            }
          });
          setLoader(false);
        } else if (allapplications.error) {
          console.log(allapplications.error);
          setLoader(false);
        }
      };
      allApplications(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  return (
    <>
      {loader ? (
        <>
          <div className={styles.headCont}>
            <h2 className={styles.head}>My applications</h2>
            <Link to="/dashboard/plan-a-trip">
              <button className={styles.headBtn}>Start New</button>
            </Link>
          </div>
          <div className={styles.loader}>
            <div className="spinner-border" role="status"></div>
          </div>
        </>
      ) : (
        <div className={styles.container}>
          <div className={styles.headCont}>
            <h2 className={styles.head}>My applications</h2>
            <Link to="/dashboard/plan-a-trip">
              <button className={styles.headBtn}>Start New</button>
            </Link>
          </div>
          <div className={styles.bloctabs}>
            {allTabs.map((value, index) => (
              <button
                key={index}
                className={
                  toggleState === index ? styles.activetabs : styles.tabs
                }
                onClick={() => toggleTab(index)}
              >
                {value.name}
              </button>
            ))}
          </div>

          <div className={styles.contenttabs}>
            {allConts.map((value, index) => (
              <div
                key={index}
                className={
                  toggleState === index ? styles.activecontent : styles.content
                }
              >
                <Tableone data={value.app} error={value.error} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default MyApplicationsMain;

function Tableone(props) {
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const data = props.data;
  const error = props.error;

  const [loader1, setLoader1] = useState(true);

  const cancelTRansaction = (id) => {
    setLoading(true);

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      const updateApplication = async (token) => {
        const update = await updateApplicationApi(id, token);

        if (update.data) {
          console.log(update.data);
          setLoader1(false);
          // history.push('/dashboard/transactions')
          // setLoading(false)
          window.location.reload();
        } else if (update.error) {
          console.log(update.error);
          setLoader1(false);
        }
      };
      updateApplication(item.value.token);
    }
    getWithExpiry("userData");
  };

  const action = (applicationId) => {
    history.push(
      `/dashboard/my-applications/application-center/${applicationId}`
    );
  };

  return (
    <div className={styles.main}>
      <div className={styles.secondSection}>
        <div className={styles.secondInsideBox}>
          {loading ? (
            <div className={styles.loader}>
              <div className="spinner-border" role="status"></div>
            </div>
          ) : data.length === 0 ? (
            <div className={styles.lengthCont}>
              <h2 className={styles.contHead}>{error}</h2>
            </div>
          ) : (
            <>
            
            <TableContainer
                        component={Paper}
                        style={{ boxShadow: "none" }}
                        className={styles.allTable}
                      >
                        <Table aria-label="caption table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center" className={styles.tableInHead}>
                                <div className={styles.tableHead}>Destination</div>
                              </TableCell>
                              <TableCell align="center" className={styles.tableInHead}>
                                <div className={styles.tableHead}>Status</div>
                              </TableCell>
                              <TableCell align="center" className={styles.tableInHead}>
                                <div className={styles.tableHead}>Action</div>
                              </TableCell>
                              <TableCell align="center" className={styles.tableInHead}>
                                <div className={styles.tableHead}></div>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                    </Table>
                    </TableContainer>
                
                    {data.map((value, index) => (
                      
                       <Collapsible
                       transitionTime={100}
                       trigger={
                        <TableContainer
                        component={Paper}
                        style={{ boxShadow: "none" }}
                        className={styles.allTable}
                      >
                        <Table aria-label="caption table">
                        
                  <TableBody>
                      <TableRow key={index}>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div className={styles.tableInHead1}>
                            {value.country}
                            <div className={styles.details}>
                              {value.visa_type}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <div className={styles.btnOne}>
                            {value.status !== undefined ? (
                              <span className={styles.status}>
                                {value.status.replace(/_/g, " ").toLowerCase()}
                              </span>
                            ) : (
                              <span className={styles.status}>
                                Not Available
                              </span>
                            )}
                          </div>
                        </TableCell>
                        <TableCell
                          className={styles.tableInHead}
                          align="center"
                        >
                          <span
                            className={styles.action}
                            onClick={() => action(value.id)}
                          >
                            <span style={{ width: "75%" }}>
                              {value.step.replace(/_/g, " ").toLowerCase()}{" "}
                              &nbsp;{" "}
                            </span>

                            <img src={greater} alt="Greater" />
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <IoChevronDownOutline
                            size={24}
                            style={{ color: "#7FA2B6" , cursor: "pointer"}}
                          />
                          {/* <img src={greater2} alt="Greater" onClick={()=>action(value.id)} style={{cursor: 'pointer'}} /> */}
                          {/* <FaGreaterThan size={20} color="#969ba0" onClick={()=>action()} /> */}
                        </TableCell>
                      </TableRow> 
                  </TableBody>
                  </Table>
              </TableContainer>

                    }>
                      <p>Hello</p></Collapsible>
                    ))}
              
              <div className={styles.allTableMobile}>
                <div className={styles.allDataMobile}>
                  <h2 className={styles.headMobile}>Country</h2>
                  <h2 className={styles.headMobile}>Action</h2>
                </div>
                {/* <hr /> */}
                {data.map((value, index) => (
                  <div key={index}>
                    <hr className={styles.lineMobile} />

                    <div className={styles.boxMobile}>
                      <div className={styles.boxInMobile}>
                        <span className={styles.nameMobile}>
                          {value.country}{" "}
                          {/* <img
                            src={greater2}
                            alt="Greater"
                            onClick={() => action(value.id)}
                            style={{ cursor: "pointer" }}
                          /> */}
                          <IoChevronDownOutline
                            size={24}
                            style={{ color: "#7FA2B6", cursor: "pointer" }}
                          />
                          {/* <FaGreaterThan size={14} color="#969ba0" onClick={()=>action()} /> */}
                        </span>
                        <br />
                        <span className={styles.detailsType}>
                          {value.visa_type}
                        </span>
                        <div className={styles.detailsStatus}>
                          {value.status !== undefined ? (
                            <span>
                              {value.status.replace(/_/g, " ").toLowerCase()}
                            </span>
                          ) : (
                            <span>Not Available</span>
                          )}
                        </div>
                      </div>
                      <div className={styles.boxInMobile2}>
                        <span
                          className={styles.btnOneMobile}
                          onClick={() => action(value.id)}
                        >
                          {value.step !== undefined ? (
                            value.step == "AWAITING_VISA_OFFICER_ASSIGNMENT" ? (
                              <span className={styles.statusMobile}>
                                Awaiting Assignment
                              </span>
                            ) : (
                              <span className={styles.statusMobile}>
                                {value.step.replace(/_/g, " ").toLowerCase()}
                              </span>
                            )
                          ) : (
                            <span className={styles.statusMobile}>
                              Not Available
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
